import axios from 'axios'

export default {
  namespaced: true,

  actions: {
    getClassrooms({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/classroom/web/getbybranch?id=" + rootGetters.getBranch.id,
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.code === 200) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    createClassroom(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/classroom/web/create",
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.code === 201) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    editClassroom(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/classroom/web/update",
          data: obj,
          method: "PUT"
        }).then(response => {
          if (response.data.code === 200) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteClassroom(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/classroom/web/delete",
          data: obj,
          method: "DELETE"
        }).then(response => {
          if (response.data.code === 200) {
            resolve(response);
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
